import axios from 'axios';
import { authHeaders } from './authServices';

export const fetchPartie = () => {
  return axios({
    method: 'get',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/groups`,
  });
};

export const deletePartiaService = (id) => {
  return axios({
    method: 'delete',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/groups/${id}`,
  });
};

export const addPartiaService = (item) => {
  return axios({
    method: 'post',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/groups`,
    data: item,
  });
};

export const editPartiaService = (id, item) => {
  return axios({
    method: 'put',
    ...authHeaders(),
    url: `${process.env.REACT_APP_DEV_URL}/api/v1/groups/${id}`,
    data: item,
  });
};
